// @ts-nocheck
(function () {
  const root = document.querySelector("[data-contact-prefs-root]");
  if (!root) return; // not on this page

  const toggles = root.querySelectorAll("[data-preference-toggle]");
  if (!toggles.length) return;

  const { ACCOUNT, CONTACT_PREFERENCES } = window.AccountEndpoints;
  const { authFetch } = window.AccountHttp;
  const { GENERIC, CONTACT_PREFERENCES: PREFS_MSG } = window.AccountMessages;

  const successBox = root.querySelector("[data-contact-prefs-success]");
  const errorBox = root.querySelector("[data-contact-prefs-error]");

  const AUTO_DISMISS_MS = 4000;
  const dismissTimers = { success: null, error: null };

  function boxKind(box) {
    return box === successBox ? "success" : "error";
  }

  function showMessage(box, message) {
    if (!box) return;

    const textEl = box.querySelector("[data-message-text]");
    if (textEl) {
      textEl.textContent = message;
    } else {
      box.textContent = message;
    }
    box.hidden = false;

    const kind = boxKind(box);
    if (dismissTimers[kind]) {
      clearTimeout(dismissTimers[kind]);
    }
    dismissTimers[kind] = setTimeout(function () {
      hideMessage(box);
    }, AUTO_DISMISS_MS);
  }

  function hideMessage(box) {
    if (!box) return;

    const kind = boxKind(box);
    if (dismissTimers[kind]) {
      clearTimeout(dismissTimers[kind]);
      dismissTimers[kind] = null;
    }

    box.hidden = true;
    const textEl = box.querySelector("[data-message-text]");
    if (textEl) {
      textEl.textContent = "";
    } else {
      box.textContent = "";
    }
  }

  function hideMessages() {
    hideMessage(successBox);
    hideMessage(errorBox);
  }

  [successBox, errorBox].forEach(function (box) {
    if (!box) return;
    const closeBtn = box.querySelector("[data-message-close]");
    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        hideMessage(box);
      });
    }
  });

  const state = {
    preferences: {},
    contactReasons: {},
  };

  // Load current preferences (C1) and set toggle states to match

  function loadPreferences() {
    return authFetch(ACCOUNT, { method: "GET" })
      .then(function (res) {
        if (!res.ok) {
          console.error(
            "[contact-preferences] Failed to load account:",
            res.data,
          );
          return;
        }

        const account = res.data.result || res.data;
        state.preferences = account.preferences || {};
        state.contactReasons = account.contactReasons || {};

        toggles.forEach(function (toggle) {
          const group = toggle.getAttribute("data-preference-group");
          const key = toggle.getAttribute("data-preference-key");
          const groupState = state[group];
          if (
            groupState &&
            Object.prototype.hasOwnProperty.call(groupState, key)
          ) {
            toggle.checked = !!groupState[key];
          } else if (groupState) {
            groupState[key] = toggle.checked;
          }
        });
      })
      .catch(function (err) {
        console.error("[contact-preferences] Failed to load account:", err);
      })
      .finally(function () {
        root.classList.remove("is-loading");
      });
  }

  loadPreferences();
  // full { preferences, contactReasons } object every time

  function savePreferences(toggle, previousValue) {
    hideMessages();
    toggle.disabled = true;

    authFetch(CONTACT_PREFERENCES, {
      method: "PUT",
      body: JSON.stringify({
        preferences: state.preferences,
        contactReasons: state.contactReasons,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error(
            (res.data && res.data.message) || PREFS_MSG.SAVE_FAILED,
          );
        }
        showMessage(
          successBox,
          (res.data.result && res.data.result.message) || PREFS_MSG.SAVED,
        );
      })
      .catch(function (err) {
        const group = toggle.getAttribute("data-preference-group");
        const key = toggle.getAttribute("data-preference-key");
        toggle.checked = previousValue;
        state[group][key] = previousValue;

        showMessage(errorBox, err.message || GENERIC.NETWORK_ERROR);
      })
      .finally(function () {
        toggle.disabled = false;
      });
  }

  toggles.forEach(function (toggle) {
    toggle.addEventListener("change", function () {
      const group = toggle.getAttribute("data-preference-group");
      const key = toggle.getAttribute("data-preference-key");
      const previousValue = !toggle.checked;

      if (!group || !key || !state[group]) {
        console.error(
          "[contact-preferences] Toggle is missing a valid data-preference-group/key:",
          toggle,
        );
        return;
      }

      state[group][key] = toggle.checked;
      savePreferences(toggle, previousValue);
    });
  });
})();
